export default __webpack_public_path__ + "static/media/telugu_agri_m.d07b18b0.wav";